<script lang="ts">
import { defineComponent } from 'vue';
import { usePoolsStore } from '@/stores/pools';
import { mapActions, mapState, mapWritableState } from 'pinia';
import { validateNumber } from '@/components/pools/helpers';
import Pagination from '@/components/pagination.vue';
import TableFiller from '@/components/table-filler.vue';
import TypesAdd from '@/components/pools/pool-types/types-add.vue';

export default defineComponent({
  name: 'types',
  components: { TypesAdd, TableFiller, Pagination },
  computed: {
    ...mapState(usePoolsStore, ['poolTypes']),
    ...mapWritableState(usePoolsStore, ['currentPoolTypeId', 'typesSize', 'typesOffset', 'typesCount']),
  },
  methods: {
    validateNumber,
    ...mapActions(usePoolsStore, ['fetchPoolTypes', 'deletePoolType']),
    flipPoolTypesPage(newOffset: number) {
      this.typesOffset = newOffset;
      this.fetchPoolTypes();
    },
  },
  mounted() {
    if (!this.poolTypes) {
      this.fetchPoolTypes();
    }
  },
});
</script>

<template>
  <table class="basic-table !text-lg" v-if="poolTypes">
    <thead>
      <tr>
        <th style="width: 80px">ID</th>
        <th>Название</th>
        <th>Мин.ставка, USD</th>
        <th>Макс.ставка, USD</th>
        <th>Количество событий</th>
        <th>Комиссия системы, %</th>
        <th><i class="pi pi-cog" /></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(type, i) of poolTypes" @click="currentPoolTypeId = type.id">
        <td>{{ type.id }}</td>
        <td class="!text-sm">{{ type.name }}</td>
        <td>{{ type.stakeMin }}</td>
        <td>{{ type.stakeMax }}</td>
        <td>{{ type.stakesCount }}</td>
        <td>{{ type.commission }}</td>
        <td><i
          class="pi pi-trash text-red-500 text- cursor-pointer text-[15px]"
          @click.stop="deletePoolType(type.id)"
        /></td>
      </tr>
      <table-filler :max="typesSize" :rows="poolTypes" />
      <types-add />
    </tbody>
  </table>
  <div class="text-center">
    <Pagination
      :offset="typesOffset"
      :size="typesSize"
      :count="typesCount"
      @flip="flipPoolTypesPage"
    />
  </div>
</template>

<style scoped lang="scss"></style>
